﻿"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Work = void 0;
const net = require("@ivanlog/net");
const models_1 = require("./models");
const models_2 = require("./models");
const models_3 = require("./models");
const models_4 = require("./models");
class Work {
    constructor(_client, _errorsHandler) {
        this._client = _client;
        this._errorsHandler = _errorsHandler;
        if (!this._errorsHandler)
            this._errorsHandler = (e, args) => { throw e; };
    }
    /**
    * Start working. Enable active vehicle. Allowed:[Driver with linked vehicle]
    * @returns {Promise<ResultFail|ActiveVehicle|net.NetError|number>}
    */
    startUnsafe(body) {
        return __awaiter(this, void 0, void 0, function* () {
            const __endpoint = "/driver/api/v1/Work/Start";
            const __query = [];
            const __addHeaders = {};
            __addHeaders['Accept'] = 'application/json';
            __addHeaders['Content-Type'] = 'application/json';
            let __data;
            let __url = __endpoint;
            __data = body;
            if (typeof __data === "object")
                __data = net.def.objToClearJSON(__data);
            if (__query.length > 0)
                __url = __url + '?' + __query.join('&');
            const __responce = yield this._client.process(net.HTTPMethods.POST, __url, __data, __addHeaders, [200, 401, 403, 422, 500]);
            const __code = __responce.status;
            let __result;
            try {
                switch (__code) {
                    case 200:
                        __result = new models_1.ActiveVehicle(yield __responce.json());
                        break;
                    case 401:
                    case 403:
                    case 500: break;
                    case 422:
                        __result = new models_2.ResultFail(yield __responce.json());
                        break;
                    default: throw new net.NetError(net.HTTPCodes.UnknownResponse);
                }
            }
            catch (e) {
                throw new net.NetError(net.HTTPCodes.BadDataFormat);
            }
            if ((__code >= 200) && (__code < 300)) {
                if (__result)
                    return __result;
                else
                    return __code;
            }
            else {
                if (__result)
                    throw __result;
                else
                    throw new net.NetError(__code);
            }
        });
    }
    /**
    * Start working. Enable active vehicle. Allowed:[Driver with linked vehicle]
    * @param {unknown} errHndlArgs? args for errorsHandler
    * @returns {Promise<ActiveVehicle>}
    */
    start(body, errHndlArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const r = yield this.startUnsafe(body);
                if (!(r instanceof models_1.ActiveVehicle))
                    throw new net.NetError(net.HTTPCodes.UnknownResponse);
                else
                    return r;
            }
            catch (e) {
                this._errorsHandler(e, errHndlArgs);
            }
        });
    }
    stopUnsafe() {
        return __awaiter(this, void 0, void 0, function* () {
            const __endpoint = "/driver/api/v1/Work/Stop";
            const __query = [];
            const __addHeaders = {};
            __addHeaders['Accept'] = 'application/json';
            let __data;
            let __url = __endpoint;
            if (__query.length > 0)
                __url = __url + '?' + __query.join('&');
            const __responce = yield this._client.process(net.HTTPMethods.DELETE, __url, __data, __addHeaders, [200, 401, 403, 422, 500]);
            const __code = __responce.status;
            let __result;
            try {
                switch (__code) {
                    case 200:
                    case 401:
                    case 403:
                    case 500: break;
                    case 422:
                        __result = new models_2.ResultFail(yield __responce.json());
                        break;
                    default: throw new net.NetError(net.HTTPCodes.UnknownResponse);
                }
            }
            catch (e) {
                throw new net.NetError(net.HTTPCodes.BadDataFormat);
            }
            if ((__code >= 200) && (__code < 300)) {
                if (__result)
                    return __result;
                else
                    return __code;
            }
            else {
                if (__result)
                    throw __result;
                else
                    throw new net.NetError(__code);
            }
        });
    }
    /**
    * Stop working. Disable active vehicle.
    Allowed:[Driver]
    * @param {unknown} errHndlArgs? args for errorsHandler
    * @returns {Promise<number>}
    */
    stop(errHndlArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const r = yield this.stopUnsafe();
                if (typeof r !== "number")
                    throw new net.NetError(net.HTTPCodes.UnknownResponse);
                else
                    return r;
            }
            catch (e) {
                this._errorsHandler(e, errHndlArgs);
            }
        });
    }
    statusUnsafe() {
        return __awaiter(this, void 0, void 0, function* () {
            const __endpoint = "/driver/api/v1/Work/Status";
            const __query = [];
            const __addHeaders = {};
            __addHeaders['Accept'] = 'application/json';
            let __data;
            let __url = __endpoint;
            if (__query.length > 0)
                __url = __url + '?' + __query.join('&');
            const __responce = yield this._client.process(net.HTTPMethods.GET, __url, __data, __addHeaders, [200, 401, 403, 422, 500]);
            const __code = __responce.status;
            let __result;
            try {
                switch (__code) {
                    case 200:
                        __result = new models_1.ActiveVehicle(yield __responce.json());
                        break;
                    case 401:
                    case 403:
                    case 500: break;
                    case 422:
                        __result = new models_2.ResultFail(yield __responce.json());
                        break;
                    default: throw new net.NetError(net.HTTPCodes.UnknownResponse);
                }
            }
            catch (e) {
                throw new net.NetError(net.HTTPCodes.BadDataFormat);
            }
            if ((__code >= 200) && (__code < 300)) {
                if (__result)
                    return __result;
                else
                    return __code;
            }
            else {
                if (__result)
                    throw __result;
                else
                    throw new net.NetError(__code);
            }
        });
    }
    /**
    * Get driver status
    * @param {unknown} errHndlArgs? args for errorsHandler
    * @returns {Promise<ActiveVehicle>}
    */
    status(errHndlArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const r = yield this.statusUnsafe();
                if (!(r instanceof models_1.ActiveVehicle))
                    throw new net.NetError(net.HTTPCodes.UnknownResponse);
                else
                    return r;
            }
            catch (e) {
                this._errorsHandler(e, errHndlArgs);
            }
        });
    }
    statusFullUnsafe() {
        return __awaiter(this, void 0, void 0, function* () {
            const __endpoint = "/driver/api/v1/Work/StatusFull";
            const __query = [];
            const __addHeaders = {};
            __addHeaders['Accept'] = 'application/json';
            let __data;
            let __url = __endpoint;
            if (__query.length > 0)
                __url = __url + '?' + __query.join('&');
            const __responce = yield this._client.process(net.HTTPMethods.GET, __url, __data, __addHeaders, [200, 401, 403, 422, 500]);
            const __code = __responce.status;
            let __result;
            try {
                switch (__code) {
                    case 200:
                        __result = new models_3.ActiveVehicleExtended(yield __responce.json());
                        break;
                    case 401:
                    case 403:
                    case 500: break;
                    case 422:
                        __result = new models_2.ResultFail(yield __responce.json());
                        break;
                    default: throw new net.NetError(net.HTTPCodes.UnknownResponse);
                }
            }
            catch (e) {
                throw new net.NetError(net.HTTPCodes.BadDataFormat);
            }
            if ((__code >= 200) && (__code < 300)) {
                if (__result)
                    return __result;
                else
                    return __code;
            }
            else {
                if (__result)
                    throw __result;
                else
                    throw new net.NetError(__code);
            }
        });
    }
    /**
    * Get driver status (full info)
    * @param {unknown} errHndlArgs? args for errorsHandler
    * @returns {Promise<ActiveVehicleExtended>}
    */
    statusFull(errHndlArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const r = yield this.statusFullUnsafe();
                if (!(r instanceof models_3.ActiveVehicleExtended))
                    throw new net.NetError(net.HTTPCodes.UnknownResponse);
                else
                    return r;
            }
            catch (e) {
                this._errorsHandler(e, errHndlArgs);
            }
        });
    }
    vehiclesUnsafe() {
        return __awaiter(this, void 0, void 0, function* () {
            const __endpoint = "/driver/api/v1/Work/Vehicles";
            const __query = [];
            const __addHeaders = {};
            __addHeaders['Accept'] = 'application/json';
            let __data;
            let __url = __endpoint;
            if (__query.length > 0)
                __url = __url + '?' + __query.join('&');
            const __responce = yield this._client.process(net.HTTPMethods.GET, __url, __data, __addHeaders, [200, 401, 403, 422, 500]);
            const __code = __responce.status;
            let __result;
            try {
                switch (__code) {
                    case 200:
                        __result = yield __responce.json();
                        for (const __rk in __result)
                            __result[__rk] = new models_4.Vehicle(__result[__rk]);
                        break;
                    case 401:
                    case 403:
                    case 500: break;
                    case 422:
                        __result = new models_2.ResultFail(yield __responce.json());
                        break;
                    default: throw new net.NetError(net.HTTPCodes.UnknownResponse);
                }
            }
            catch (e) {
                throw new net.NetError(net.HTTPCodes.BadDataFormat);
            }
            if ((__code >= 200) && (__code < 300)) {
                if (__result)
                    return __result;
                else
                    return __code;
            }
            else {
                if (__result)
                    throw __result;
                else
                    throw new net.NetError(__code);
            }
        });
    }
    /**
    * Get linked vehicles of driver. Allowed:[Driver]
    * @param {unknown} errHndlArgs? args for errorsHandler
    * @returns {Promise<Array<Vehicle>>}
    */
    vehicles(errHndlArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const r = yield this.vehiclesUnsafe();
                if (!(Array.isArray(r)))
                    throw new net.NetError(net.HTTPCodes.UnknownResponse);
                else
                    return r;
            }
            catch (e) {
                this._errorsHandler(e, errHndlArgs);
            }
        });
    }
    /**
    * Update active vehicle free status. When busy, hot orders are not offered. Allowed:[Driver]
    * @returns {Promise<ResultFail|ActiveVehicle|net.NetError|number>}
    */
    updateStatusUnsafe(isFree) {
        return __awaiter(this, void 0, void 0, function* () {
            const __endpoint = "/driver/api/v1/Work/UpdateStatus";
            const __query = [];
            const __addHeaders = {};
            __addHeaders['Accept'] = 'application/json';
            let __data;
            let __url = __endpoint;
            __query.push("isFree=" + encodeURIComponent(isFree));
            if (__query.length > 0)
                __url = __url + '?' + __query.join('&');
            const __responce = yield this._client.process(net.HTTPMethods.PUT, __url, __data, __addHeaders, [200, 401, 403, 422, 500]);
            const __code = __responce.status;
            let __result;
            try {
                switch (__code) {
                    case 200:
                        __result = new models_1.ActiveVehicle(yield __responce.json());
                        break;
                    case 401:
                    case 403:
                    case 500: break;
                    case 422:
                        __result = new models_2.ResultFail(yield __responce.json());
                        break;
                    default: throw new net.NetError(net.HTTPCodes.UnknownResponse);
                }
            }
            catch (e) {
                throw new net.NetError(net.HTTPCodes.BadDataFormat);
            }
            if ((__code >= 200) && (__code < 300)) {
                if (__result)
                    return __result;
                else
                    return __code;
            }
            else {
                if (__result)
                    throw __result;
                else
                    throw new net.NetError(__code);
            }
        });
    }
    /**
    * Update active vehicle free status. When busy, hot orders are not offered. Allowed:[Driver]
    * @param {unknown} errHndlArgs? args for errorsHandler
    * @returns {Promise<ActiveVehicle>}
    */
    updateStatus(isFree, errHndlArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const r = yield this.updateStatusUnsafe(isFree);
                if (!(r instanceof models_1.ActiveVehicle))
                    throw new net.NetError(net.HTTPCodes.UnknownResponse);
                else
                    return r;
            }
            catch (e) {
                this._errorsHandler(e, errHndlArgs);
            }
        });
    }
    /**
    * Update active vehicle position. Allowed:[Driver]
    * @returns {Promise<ResultFail|ActiveVehicle|net.NetError|number>}
    */
    updatePositionUnsafe(body) {
        return __awaiter(this, void 0, void 0, function* () {
            const __endpoint = "/driver/api/v1/Work/UpdatePosition";
            const __query = [];
            const __addHeaders = {};
            __addHeaders['Accept'] = 'application/json';
            __addHeaders['Content-Type'] = 'application/json';
            let __data;
            let __url = __endpoint;
            __data = body;
            if (typeof __data === "object")
                __data = net.def.objToClearJSON(__data);
            if (__query.length > 0)
                __url = __url + '?' + __query.join('&');
            const __responce = yield this._client.process(net.HTTPMethods.PUT, __url, __data, __addHeaders, [200, 401, 403, 422, 500]);
            const __code = __responce.status;
            let __result;
            try {
                switch (__code) {
                    case 200:
                        __result = new models_1.ActiveVehicle(yield __responce.json());
                        break;
                    case 401:
                    case 403:
                    case 500: break;
                    case 422:
                        __result = new models_2.ResultFail(yield __responce.json());
                        break;
                    default: throw new net.NetError(net.HTTPCodes.UnknownResponse);
                }
            }
            catch (e) {
                throw new net.NetError(net.HTTPCodes.BadDataFormat);
            }
            if ((__code >= 200) && (__code < 300)) {
                if (__result)
                    return __result;
                else
                    return __code;
            }
            else {
                if (__result)
                    throw __result;
                else
                    throw new net.NetError(__code);
            }
        });
    }
    /**
    * Update active vehicle position. Allowed:[Driver]
    * @param {unknown} errHndlArgs? args for errorsHandler
    * @returns {Promise<ActiveVehicle>}
    */
    updatePosition(body, errHndlArgs) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const r = yield this.updatePositionUnsafe(body);
                if (!(r instanceof models_1.ActiveVehicle))
                    throw new net.NetError(net.HTTPCodes.UnknownResponse);
                else
                    return r;
            }
            catch (e) {
                this._errorsHandler(e, errHndlArgs);
            }
        });
    }
}
exports.Work = Work;
//# sourceMappingURL=Work.js.map